/** Internal print-category anchor — matches api-server seed `habits-exclusive`. */
export const HABITS_EXCLUSIVE_PRINT_CATEGORY_KEY = "habits-exclusive";

const DECORATION_REFERENCE_FOLDER = "design-requests/references";
const DECORATION_REFERENCE_PDF = "CustomOptions_Chart-2.pdf";

/** Mirrors api-server `CDN_URL` — dev vs prod assets host. */
export function getHabitsAssetsCdnBase(): string {
  /* `?.`: node --test loads this module without Vite, where import.meta.env is undefined. */
  const fromEnv = import.meta.env?.VITE_CDN_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/+$/, "");
  return import.meta.env?.PROD
    ? "https://assets.habits365greek.com"
    : "https://dev-assets.habits365greek.com";
}

export const HABITS_DECORATION_REFERENCE_PDF_URL = `${getHabitsAssetsCdnBase()}/${DECORATION_REFERENCE_FOLDER}/${DECORATION_REFERENCE_PDF}`;
